export default __webpack_public_path__ + "767ebf5b16574c6f2087c2240bf04a77.svg";